export enum MenuMode {
  PRODUCT_LIST = "PRODUCT_LIST",
  CATEGORY_LIST = "CATEGORY_LIST"
}

